import { colors } from '../../../constants/styleConstants';

export const viewByFilterStyle = {
  viewBy: {
    display: 'flex',
  },
  viewByLabel: {
    padding: '6px 6px 6px 0',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: '1.5',
    letterSpacing: '0.15px',
    color: colors.lightBlack,
    marginRight: 16,
  },
  checkboxViewBy_disabled: {
    display: 'none',
  },
  checkboxViewBy: {
    minWidth: 55,

    '& .Mui-focusVisible': {
      color: colors.darkBlue,

      '& ~ .MuiFormControlLabel-label': {
        color: colors.darkBlue,
      },
    },

    '& .MuiFormControlLabel-label': {
      fontSize: 14,
    },

    '& .Mui-checked': {
      color: colors.darkBlue,
    },

    '& .MuiIconButton-label': {
      width: 18,
      height: 18,
    },

    '&:hover': {
      color: colors.darkBlue,

      '& .MuiIconButton-label': {
        color: colors.darkBlue,
      },
    },

    '&:active': {
      color: colors.darkBlue,

      '& .MuiIconButton-label': {
        color: colors.darkBlue,
      },
    },

    '&:focus': {
      color: colors.darkBlue,

      '& .MuiIconButton-label': {
        color: colors.darkBlue,
      },
    },
  },
};
